import React, { Component, Fragment } from 'react';
import Login from '../../../assets/images/logo4.png';
// import './style.css';
import UtilityService from '../../../services/utility.service.js'
import cookie from 'react-cookies';

//redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import * as mainAction from "../../redux/action/main";
import * as mainAction from "../../../redux/action/main.js"
//component
import Loading from '../../../components/Common/Loading'
import Logo from "../../../assets/images/MobileApp/logo4 1 (2).svg"

class LogInPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: "",
            password: "",
            remember: false,
            loader : false,
        }
        this.submitLogin = this.submitLogin.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.props.actions.updateBasicDetails = this.props.actions.updateBasicDetails.bind(this);
        this.captureEnter = this.captureEnter.bind(this);
    }

    componentDidMount(){
        window.addEventListener('keypress',this.captureEnter)
    }

    componentWillMount() {
        if (cookie.load('userId') !== undefined && cookie.load('password') !== undefined){
            this.setState({ userId: cookie.load('userId'), password: cookie.load("password"), remember: true })
        }
    }

    componentWillUnmount(){
        window.removeEventListener('keypress',this.captureEnter)
    }

    async captureEnter(e){
        if(e.key == "Enter"){
            this.submitLogin(e)
        }
    }

    async submitLogin(e) {
        e.preventDefault();
        let userDetails = {
            userId: this.state.userId,
            password: this.state.password,
            rememberMe: this.state.remember
        }

        if (this.state.userId == "" || this.state.password == "") {
            alert("Please fill all fields");
            return;
        }

        this.setState({ loader : true })
        await fetch(UtilityService.baseUrl() + 'api/employee/login', {
            method: "POST",
            body: JSON.stringify(userDetails),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': UtilityService.authToken()
            },
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.message === "Successfully logged in") {
                    localStorage.setItem("authToken", responseJson.data.authToken)
                    let userDetails = {
                          userName : responseJson.data.name,
                          userId : responseJson.data._id,
                          authToken : responseJson.data.authToken,
                          profilePicture : responseJson.data.profilePicture,
                          isLoggedIn : true,
                          rights : responseJson.data.rights
                    }
                    this.props.actions.updateBasicDetails(userDetails);
                    this.props.history.push('/qr')
                    this.setState({ loader : false })
                }
                else if(responseJson.message == 'Wrong Password'){
                    this.props.getalertMessage('error',responseJson.message)
                    this.setState({
                        password  : ""
                    })
                    this.setState({ loader : false })
                }
                else {  
                    this.props.getalertMessage('error',responseJson.message)
                    this.setState({ loader : false })
                }

            }).catch((error) => {
                let userDetails ={
                    isLoggedIn : false
                }

                this.setState({ loader : false })

                this.props.actions.updateBasicDetails(userDetails)
                this.props.getalertMessage('error',error)
            })
    }
    changeRemember(e){
        this.setState({remember: !this.state.remember },function(){
            if (this.state.remember === true && this.state.userId !== "" && this.state.password !== ""){

                cookie.save('userId', this.state.userId, { path: '/qr' })
                cookie.save('password', this.state.password, { path: '/qr' })
            }
            else if (this.state.userId !== "" && this.state.password !== ""){
                cookie.remove("userId")
                cookie.remove("password")
            }
        })
    }

    handleFormChange(event) {

        event.preventDefault();

        if (event.key === "Enter") {
            this.submitLogin();
            return;
        }

        let key = event.target.id, val = event.target.value;

        if (key == "userId") {
            this.setState({ userId: val })
        } else if (key == "password") {
            this.setState({ password: val })
        } else {
            this.setState({ remember: val })
        }

    }

    render() {
        if(!this.state.loader){
        return (
            <Fragment>
                {/* <div className="grid-container">
                        <div>
                            <div style={{ position: "relative" }} className="h-100">
                                <div className="login-left-section">
                                    <img src={Login} alt="logo" className="logo-image" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="login-right-section h-100 d-flex align-items-center">
                                <div className="login-form-container p-0 mx-auto w-75">
                                    <form onSubmit={(e)=> this.submitLogin(e)}>
                                        <h3 className="whiteColor lato">Magnum Login</h3>

                                        <input type="text" className="login-input whiteColor lato" value={this.state.userId} id="userId" onChange={this.handleFormChange} placeholder="UserId" />
                                        <input type="password" className="login-input whiteColor lato" id="password" value={this.state.password} onChange={this.handleFormChange} placeholder="Password" />
                                        {/* <Switch onClick={(e) => this.changeRemember(e) } on={this.state.remember} className='other-class ml-3 login' style={{ color: "red" }} /> 
                                    <p className="lato ml-3 pTag manage_permissions emb-chck">
                                    <input type="checkbox" 
                                        class="filled-in"
                                        id="remember"
                                        name = "remember"    
                                        checked ={this.state.remember}
                                        value ={this.state.remember}
                                        onChange={(e) =>{
                                            this.setState({
                                            remember : e.target.checked

                                            })
                                        }}
                                    />
                                    <label for="remember" className="text-white ">
                                        Keep me logged in
                                    </label>
                                    </p>
                                        <button type="submit" className="login-submit-btn lato" onClick={this.submitLogin} >LOGIN</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className='container login-container'>
                    <div>
                        <img src={Logo} alt="Magnum Logo" />
                    </div>
                    <div style={{margin:"20px 0px",color:"rgba(0, 150, 136, 1)",fontSize:"20px",fontWeight:"600"}}>
                        <span>LOG IN</span>
                    </div>
                    <div className='log-form1' style={{width:"100%"}}>
                        <div className='log-form-col1'>
                        <span className='label1'>User ID*</span>
                        <input type="text" className='log-inp' value={this.state.userId}
                            onChange={this.handleFormChange} id="userId" placeholder='User ID' />
                        </div>
                        <div className='log-form-col1'>
                            <span className='label1'>Password*</span>
                            <input type="password" className='log-inp' value={this.state.password}
                            onChange={this.handleFormChange} id="password" placeholder='Password' />
                            </div>    
                    </div>
                    <div className='log-con-btn'>
                        <button className='log-btn1' onClick={this.submitLogin}>LOG IN</button>
                    </div>
                    </div>
                    



            </Fragment>
        );
        }else{
            return <Loading />
        }
    }
}


const mapDispatchToProps = dispatch => {
return { actions: bindActionCreators(mainAction, dispatch) };
};

export default connect(
null,
mapDispatchToProps
)(LogInPage);




// WEBPACK FOOTER //
// ./src/pages/Sample/SampleMobileApp/MobileLogin.js